module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e538"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0310252342_content_0021_009",
      "id": "d12e539",
      "src": "images/0310252342_content_0021_009.jpg"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Morr_9780310252344_epub_c3d_r1#d12e183",
      "id": "d12e540"
    }
  }, [_vm._v("Chapter 2 ")]), _c('img', {
    attrs: {
      "alt": "0310252342_content_0021_010",
      "id": "d12e542",
      "src": "images/0310252342_content_0021_010.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e543"
    }
  }, [_c('b', [_vm._v("T")]), _vm._v("he following Saturday afternoon, Lanie bustled around the kitchen, gathering towels and soap for baths. Hot water bubbled on the stove, and the kitchen was filled with a warm glow. The cookstove, Warm Morning, was the pride of Lanie’s heart. The bottom of the stove contained a wood box, which heated the oven, and at eye level were two warming bins. Everyone had crowded into the kitchen, for the arrival of January had brought with it freezing blasts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e547"
    }
  }, [_vm._v("“Davis, you go get the wash tub. We’re going to have to take baths in the kitchen tonight.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e549"
    }
  }, [_vm._v("Cody spoke up at once. “I don’t need a bath.” He was sitting at the table playing dominoes with Corliss. “Elijah never took no baths,”he said as if that settled the argument.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e551"
    }
  }, [_vm._v("“How do you know?” Lanie said. “The Bible doesn’t say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e553"
    }
  }, [_vm._v("“Well, it ort to! The body’s got natural oils. When you wash ’em off, germs can get in and kill you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e555"
    }
  }, [_vm._v("Maeva laughed. She was sitting on the other side of the table reading a library book. She glanced at him over the top. “You’re as dirty as a pig, Cody.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e557"
    }
  }, [_vm._v("“I’m not neither. You just don’t understand the scientific way dirt works. You see, when dirt gets on you, it stays a while and then it falls off. Can’t stay on you forever. If it did, you’d be a mud ball. So I just let it fall off.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e559"
    }
  }, [_vm._v("“You’re going to take a bath. I don’t care what you say.” Lanie was accustomed to Cody’s high-flying explanations, most of which made as little sense as this one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e561"
    }
  }, [_vm._v("Cody would have defended his thesis more vociferously, but a sudden sound of footsteps on the back porch made them all turn to look. “Who can that be?” Lanie said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e563"
    }
  }, [_vm._v("She went at once to the door, opened it, and found a man standing there, soft cap in hand. He looked to be in his mid-fifties, and sadness hung over him. “Hello, ma’am,” he said. “Can I cut wood in exchange for something to eat?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e566"
    }
  }, [_vm._v("Lanie was accustomed to the hoboes, for the Freemans lived close to the railroad watering stop. Many would get off the train here and wander through town, and for the most part, she had stopped being afraid of them. She hesitated for a moment, wondering what to do, then nodded. “We’ll find something. Come on in.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e568"
    }
  }, [_vm._v("“My name’s John Simmons,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e570"
    }
  }, [_vm._v("“Well, Mr. Simmons, this is our family.” She introduced everyone and said, “You sit down here while I fix you a plate.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e572"
    }
  }, [_vm._v("Her eyes big, Corliss watched the hobo. “Hello,” she said. “My name is Corliss. I’m three years old.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e574"
    }
  }, [_vm._v("The man suddenly smiled, and his whole face lit up. “Well, hello, Corliss, three years old. My name is John Simmons, and I’m fifty-three years old.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e576"
    }
  }, [_vm._v("“That’s pretty old.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e578"
    }
  }, [_vm._v("“It is, for a fact.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e580"
    }
  }, [_vm._v("Lanie quickly fried up three eggs and ham. She added some biscuits left over from breakfast and set a plateful before Simmons. He stared at it, then said, “This looks mighty good. I’m thankful to the Lord for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e582"
    }
  }, [_vm._v("“Where are you from, Mr. Simmons?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e584"
    }
  }, [_vm._v("“Detroit, Michigan. I came down here to escape the cold weather.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e586"
    }
  }, [_vm._v("He began to eat, and they all noticed that he did not gobble his food as many would but ate in a rather refined fashion. “It looks like you folks have cold weather here too.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e589"
    }
  }, [_vm._v("“Unusual for this time of the year. Now, Davis, you mind what I said about getting the tub in. Everybody’s got to be washed off.”She spoke mainly to turn the attention of the youngsters away from John Simmons. She knew their curious stares must be embarrassing, and she did her best to keep them occupied until he had finished.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e591"
    }
  }, [_vm._v("“I’d like to have a shot at that woodpile.” He looked over at Davis and Cody. “But that’s not my real kind of work. I was a barber for a lot of years.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e593"
    }
  }, [_vm._v("“A barber!” Lanie exclaimed. “We’ve got two prime candidates here. Get the high stool, Cody. You’re about to get shorn.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e595"
    }
  }, [_vm._v("“Aw, I don’t need no haircut. Look at the trouble ol’ Samson got into when that Delilah cut his hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e597"
    }
  }, [_vm._v("“Just stop arguing. I declare. You’d argue with an anvil!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e599"
    }
  }, [_vm._v("Ten minutes later Cody was in the chair, and John Simmons was performing a beautiful haircut on him. “You’ve got a well-shaped head, son,” Simmons said, cheerfully snipping and then brushing it back. “Some people have odd-shaped heads, and you can’t do much with ’em.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e601"
    }
  }, [_vm._v("“Yes, I sure do have a good-shaped head,” Cody agreed. “You take old Robert Flyer at school, he’s got a head shaped like a square box. And Minnie Dixon, her head’s shaped like an egg. Couldn’t do much for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e603"
    }
  }, [_vm._v("Lanie smiled. “Well, that’s a beautiful haircut. Davis, you get up there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e605"
    }
  }, [_vm._v("Davis got onto the stool, and Simmons put the cloth around his neck and tied it. “My head’s not as beautiful as my brother’s — ” he winked at the newfound barber — “but just do the best you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e607"
    }
  }, [_vm._v("They all watched as the barber cut Davis’s hair with quiet efficiency. He was peppered with questions, mostly by Cody, with a few thrown in by Corliss. Finally, Lanie said, “My land, you kids would drive a body crazy. When you finish there, I’ll fix you up with some food to take with you, Mr. Simmons.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e609"
    }
  }, [_vm._v("“Mighty kind of you, miss.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e612"
    }
  }, [_vm._v("Lanie filled an enormous sack with as much nonperishable food as she could. Then she added bologna sandwiches, two hardboiled eggs, and two fried apple pies. When she opened the door for the man, she put her hand out. “May God bless you, my dear friend, and go before you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e614"
    }
  }, [_vm._v("John Simmons swallowed hard. “I wish there were more folks like you in the world,” he said, then turned and left. He did not look back once.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e616"
    }
  }, [_vm._v("Lanie closed the door and sighed. “It makes me sad to see all those men out in the world with no place to go and no work to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "0310252342_content_0024_004",
      "id": "d12e618",
      "src": "images/0310252342_content_0024_004.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e619"
    }
  }, [_vm._v("Baths were over and the sun was going down in a rosy haze when Lanie opened the door and found Roger grinning at her. “Roger,” she exclaimed. “What are you doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e621"
    }
  }, [_vm._v("“Just finished packing for college and I decided I had to see my best girl once more before I left.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e623"
    }
  }, [_vm._v("As Roger followed Lanie into the house, she said, “Why, Roger, you got rid of your crutch!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e625"
    }
  }, [_vm._v("“Right. Just a cane now. Pretty soon I’ll even get rid of that.” He came forward and pulled Lanie into a bear hug.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e627"
    }
  }, [_vm._v("“Roger, you’re squashing me,” she cried out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e629"
    }
  }, [_vm._v("“Well, you shouldn’t smell so good.” Roger was a tall young man of twenty. With his blonde hair and bright blue eyes, he was considered quite a catch in the Fairhope circle. True, he’d had trouble with his father, Otis. He also had broken his leg at Thanksgiving when he’d fallen into a deep canyon while hunting alone. He’d been found only by the efforts of Lanie and Booger, a bloodhound she had nursed back to life — or some said, prayed back to life. Lanie and the hound, along with Doctor Owen Merritt, had tracked Roger, an act that saved his life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e631"
    }
  }, [_vm._v("“Come on into the kitchen. Have you had supper?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e634"
    }
  }, [_vm._v("“Yes. I’ve already eaten.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e636"
    }
  }, [_vm._v("“We’ve got something you’re going to like.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e638"
    }
  }, [_vm._v("Roger winked and squeezed Lanie’s arm. “I found something I already like.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e640"
    }
  }, [_vm._v("“Now you stop that, Roger.” Lanie smiled. She could not help but enjoy the young man. He was imminently likeable and had already given an indication he had fallen in love with her. She was not sure how she felt about him, but she knew she would not fit into his family if she were to marry him. But he had been good to the Freemans, and when they entered the kitchen, they greeted him riotously.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e642"
    }
  }, [_vm._v("“Some people will do anything to get sympathy.” Davis grinned as he walked over to shake hands. “Falling down a mountain and breaking a leg is going a bit too far.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e644"
    }
  }, [_vm._v("Corliss held up her arms. “Hello, Roger.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e646"
    }
  }, [_vm._v("With one arm, Roger picked her up and said, “How’s my best girl?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e648"
    }
  }, [_vm._v("“Who is she?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e650"
    }
  }, [_vm._v("“Why, you are. Now give me a kiss.” He took the kiss on his cheek and said, “Now, don’t you be giving any kisses away. They all belong to me.” He turned to Cody and said, “What’s the latest invention, Cody?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e652"
    }
  }, [_vm._v("“Whatever it is, it doesn’t work,” Maeva said. “You look good, Roger. It always hurts my feelings when you come to see Lanie and never me. Everybody knows I’m better-looking than she is. I can dance better too.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e654"
    }
  }, [_vm._v("“Well, when Lanie throws me out, you’ll be first on my list, Maeva.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e657"
    }
  }, [_vm._v("Aunt Kezia was sitting on a tall stool watching Roger. She liked him a great deal but would never let it be known. “Well, if it isn’t Roger Langley himself,” Kezia said. “Good to see you ain’t broke any more legs.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e659"
    }
  }, [_vm._v("“Hello, Aunt Kezia. You’re looking beautiful, as usual.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e661"
    }
  }, [_vm._v("Kezia made a face at him. “Don’t be trying any of your wiles on me. I’m past that stage.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e663"
    }
  }, [_vm._v("“Try your wiles on me,” Corliss piped up and then frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e665"
    }
  }, [_vm._v("“What’s a "), _c('i', [_vm._v("wile")]), _vm._v(", anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e670"
    }
  }, [_vm._v("“Never you mind.” Roger grinned. “You’ll find out soon enough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e672"
    }
  }, [_vm._v("Learn any new songs?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e674"
    }
  }, [_vm._v("“Yes. I know lots of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e676"
    }
  }, [_vm._v("“She knows too many of them.” Lanie shook her head with wonder. “She hears a song one time and it’s in her head for good.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e678"
    }
  }, [_vm._v("“You want to hear a song about a chigger?” Corliss demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e680"
    }
  }, [_vm._v("“I sure do, honey.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e683"
    }
  }, [_vm._v("As she sang, her eyes were alive with pleasure. The others smiled, clapping their hands in time, and occasionally Booger lifted his head and howled in a high-pitched moaning fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d12e685"
    }
  }, [_c('i', [_vm._v("There was a little chigger"), _c('br'), _vm._v("And he wasn’t any bigger"), _c('br'), _vm._v("Than the wee small head of a pin.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d12e692"
    }
  }, [_c('i', [_vm._v("But the bump that he raises"), _c('br'), _vm._v("Well, it itches like blazes"), _c('br'), _vm._v("And that’s where the rub comes in.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e699"
    }
  }, [_vm._v("Roger laughed and said, “That’s a beautiful song. I’ll have to learn that one for sure.” He took a chair and pulled Corliss up in his lap.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e701"
    }
  }, [_vm._v("Aunt Kezia announced, “I’m fixing to make something good.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e703"
    }
  }, [_vm._v("You can watch, all of you, but keep your hands off.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e705"
    }
  }, [_vm._v("“This some kind of a secret formula?” Roger teased. “Maybe a potion to make all the girls fall in love with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e707"
    }
  }, [_vm._v("“Never you mind about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e709"
    }
  }, [_vm._v("They all watched as Aunt Kezia moved around the kitchen, gathering ingredients. She put in a cup of sugar, a third of a cup of water, a pinch of salt, and then held up a jug of sorghum. It glugged three times, and she said, “That’ll be about right. Three glugs usually does it.” She added a cup of butter, some vanilla, and then stirred it thoroughly. “Now, Lanie,” she said, “get that popcorn started.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e711"
    }
  }, [_vm._v("Everyone knew how to make popcorn, so it wasn’t long before the kitchen was filled with the sounds of pops and bangs and the heavenly scent of the exploding kernels.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e713"
    }
  }, [_vm._v("While all this was happening, Davis picked his fiddle up and started to play and sing. Before he reached the end of the first verse of the old tune “Sourwood Mountain,” Maeva joined in, blending her voice with his.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e716"
    }
  }, [_vm._v("Aunt Kezia tapped her foot to the music while she stirred the syrup. After a few minutes, she said, “Come over here, honey.” Corliss stood beside her, and Kezia poured a cup of cold water. “Now, you just put a drop of that syrup in there. If it makes a ball, we’ll know it’s ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e718"
    }
  }, [_vm._v("“All right, Aunt Kezia.” Corliss took the spoon and carefully tilted it until a dollop of syrup fell into the water. “Look,” she said, “it’s all ready! See? It’s got a ball.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e720"
    }
  }, [_vm._v("“All right. We’re going to make popcorn balls now.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e722"
    }
  }, [_vm._v("The children had not done anything like this before, but they all threw themselves into the task. Lanie poured the popcorn out on a piece of oilcloth, and then Aunt Kezia ladled syrup over it. The rest crowded in, buttered their fingers, and started forming the sticky popcorn into balls.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e724"
    }
  }, [_vm._v("“You make ’em as big or as little as you want,” Aunt Kezia said. “I like ’em little myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e726"
    }
  }, [_vm._v("“Where’d you learn to do this, Aunt Kezia?” Lanie asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e728"
    }
  }, [_vm._v("“Oh, my law. I was no older than Corliss here when I learned how to make popcorn balls.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e730"
    }
  }, [_vm._v("“These are good!” Roger said, munching into one. “Couldn’t find anything better than this at a carnival.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e732"
    }
  }, [_vm._v("The rest of the evening was spent filling up on popcorn balls and playing music and checkers — which turned into a tournament that Davis won without trying. "), _c('i', [_vm._v("He can do anything better than anyone")]), _vm._v(", Lanie thought sadly, "), _c('i', [_vm._v("as long as it doesn’t involve reading. He’s so smart, ")]), _c('i', [_vm._v("but why can’t he read?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e741"
    }
  }, [_vm._v("As Roger put on his coat and scarf, he winked at Corliss. “You going to marry me when you grow up, good-looking?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e743"
    }
  }, [_vm._v("“Yes,” Corliss said at once. “Do you like kissing?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e746"
    }
  }, [_vm._v("“You bet!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e748"
    }
  }, [_vm._v("Maeva, who was standing nearby, laughed. “I like it too,” she said. “I’ll come along while you say good-bye to Roger, Lanie, to see that you do it right.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e750"
    }
  }, [_vm._v("“You stay right here, Maeva,” Lanie said. She put on a sweater and walked outside with Roger. “Not much privacy in our house.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e752"
    }
  }, [_vm._v("“I like it though. Something’s always going on.” They stood on the front porch, looking out at the starry night, then he turned to her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e754"
    }
  }, [_vm._v("“I hate to leave and go back to school.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e756"
    }
  }, [_vm._v("“It’s too bad the college isn’t here in Fairhope.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e758"
    }
  }, [_vm._v("Roger reached for her suddenly, pulled her close, and kissed her warmly. “Your nose is cold.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e760"
    }
  }, [_vm._v("“So is yours.” She put her hand on his cheek. “Write to me, will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e762"
    }
  }, [_vm._v("“Yes. And you can write a poem to me about how wonderful I am and how much you love me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e764"
    }
  }, [_vm._v("“You go along now. You’re supposed to write the poems.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e766"
    }
  }, [_vm._v("“All right. Maybe I will. When are you going to see your father?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e769"
    }
  }, [_vm._v("“Day after tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e771"
    }
  }, [_vm._v("“Tell him I wish him well and that I’m praying for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e773"
    }
  }, [_vm._v("“Good night, Roger.” She watched as Roger walked back to his father’s car, got in awkwardly, and pulled away from the curb. He waved to her, and she waved back, thinking, "), _c('i', [_vm._v("He’s the best young man I ")]), _c('i', [_vm._v("know. Why can’t I fall desperately in love with him?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e779"
    }
  }, [_vm._v("There was no answer to this, so she turned and went back into the house. ")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "0310252342_content_0028_016",
      "id": "d12e781",
      "src": "images/0310252342_content_0028_016.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e782"
    }
  }, [_vm._v("Early the following week Lanie went alone to visit her father. The trip to see him was always bittersweet. She was always eager to see her dad, but the circumstances were almost too much to bear. As she approached Cummings Prison Farm, a pall seemed to descend on her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e784"
    }
  }, [_vm._v("The prison farm was surrounded by barbed wire and there was nothing attractive about it. It had not been built for architectural beauty but to contain criminals.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e786"
    }
  }, [_vm._v("Lanie presented her pass to the guards at the gate and then repeated the process as she encountered still other guards inside, until at last she was permitted to continue on to the warden’s house. At each checkpoint, the contents of the bag she carried were examined.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e788"
    }
  }, [_vm._v("At last she saw her father. He was outside the warden’s house walking a rawboned gelding back and forth. The horse’s breath rose like steam in the cold air, and his eyes looked wild.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e790"
    }
  }, [_vm._v("“Hello, Daddy, that’s a bad horse you got there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e792"
    }
  }, [_vm._v("Forrest turned and suddenly his whole face lit up. He was a handsome man of six feet with crisp brown hair and blue eyes. After tying the horse up, he wrapped his arms around her, holding her tight. She clung to him and said, “I’m so glad to see you, Daddy. I brought you lots of good things to eat.” She pulled back and smiled up at him, trying not to worry over the new lines in his face, the sad slope of his shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e795"
    }
  }, [_vm._v("“Well, it’s about dinnertime here, and we’re going to eat first class.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e797"
    }
  }, [_vm._v("I made it all right with the warden. We can eat in the kitchen.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e799"
    }
  }, [_vm._v("The two went in the kitchen and sat down across from each other at a small, scarred table. Lanie spoke rapidly, bringing Forrest up to date on the news of the family and the town. Her father leaned forward, the look in his eyes telling her how hungry he was for such news. It hurt her to see what prison had done to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e801"
    }
  }, [_vm._v("The dinner was excellent. A black cook named Malachi served them fried pork chops, fried potatoes, and greens. “I growed them greens in our own greenhouse, missy,” he said. “The warden, he got to have his greens.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e803"
    }
  }, [_vm._v("“I probably eat better than any inmate in this whole place.” For-rest smiled. “Gonna get fat if I keep on eating Malachi’s cooking.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e805"
    }
  }, [_vm._v("Lanie tried to return the smile, but it was a forced effort. Her father did not look well. He had lost weight. She could tell from the hollows in his cheeks, and there were lines around his eyes that she had never noticed before today. She did not mention it. Instead, she gave him news of Booger. “You’d be so proud of him, Daddy. He looks so good.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e807"
    }
  }, [_vm._v("“Don’t tell the warden that. He’d want him back. He says that bloodhound was the best this place ever had.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e809"
    }
  }, [_vm._v("They talked for a while about the dogs and the animals, and then Forrest said, “How’s the girl doing? Cass, I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e811"
    }
  }, [_vm._v("“Well, she has real good times and real bad times. She’s had such a hard life, Daddy, and now here she is, just a child really, going to have a baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e813"
    }
  }, [_vm._v("“That’s always hard to hear. But you’re doing the right thing, taking care of her.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e815"
    }
  }, [_vm._v("Lanie had formed a habit of making a list of things to talk to her father about. She wanted to bring him as much of home as she could.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e818"
    }
  }, [_vm._v("“A funny thing happened just a few days ago. Aunt Kezia was making a cake, and Cass sat on a stool watching her. Cass had been telling her how sad she was and how there wasn’t much hope for her. She was about to start crying when Aunt Kezia said, ‘You love cake?’")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e820"
    }
  }, [_vm._v("“ ‘Why, yes, I love cake,’ Cass said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e822"
    }
  }, [_vm._v("“ ‘Well, here. Have some cooking oil.’ Aunt Kezia poured some cooking oil out into a glass and handed it to her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e824"
    }
  }, [_vm._v("“ ‘Ooh, I can’t drink that,’ Cass said. ‘It’s awful.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e826"
    }
  }, [_vm._v("“ ‘Well, here. Try a couple of raw eggs.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e828"
    }
  }, [_vm._v("“ ‘Why, that’s terrible! Nobody could eat raw eggs.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e830"
    }
  }, [_vm._v("“ ‘Well, how about some flour then, or maybe you would like some baking soda?’")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e832"
    }
  }, [_vm._v("“She kept shoving all the ingredients of the cake toward Cass, and Cass just sat there making faces and saying no.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e834"
    }
  }, [_vm._v("“Finally Aunt Kezia said, ‘Girl, all these things seem bad by themselves, but when they’re put together in the right way, they make a wonderful cake.’ ” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e836"
    }
  }, [_vm._v("Lanie smiled. “Then Aunt Kezia went on to say, ‘God works the same way. He lets us go through hard times, but He knows how to put all these things in order. And when He puts all the ingredients together, He’s going to give you a cake.’ That’s what she said to Cass. It made Cass feel good too. She laughed and put her arms around Aunt Kezia and told her she wanted to make cakes.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e838"
    }
  }, [_vm._v("“That’s a wonderful story, daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e841"
    }
  }, [_vm._v("The two continued talking, and suddenly Warden Potter Gladden came in. He was a short, stocky man with intent gray eyes, and although he had a difficult job, he always had a warm smile for Lanie or for any of Forrest’s relatives. “Hello. How’s my favorite girl doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e843"
    }
  }, [_vm._v("“I’ll bet you say that to all the girls, Warden.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e845"
    }
  }, [_vm._v("“Did Malachi fix you up with a good dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e847"
    }
  }, [_vm._v("“Wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e849"
    }
  }, [_vm._v("“Best cook I ever had. He’ll be out next month. I find myself halfway hoping he’ll run a stoplight or something and get sent back here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e851"
    }
  }, [_vm._v("Malachi, who had been listening, said, “No, suh, Warden, you do your own cooking. When I get out of here you seen the last of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e853"
    }
  }, [_vm._v("“I hope I have seen the last of him. He’s a good man. I’ll see you before you leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e855"
    }
  }, [_vm._v("“All right, Warden.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "0310252342_content_0031_011",
      "id": "d12e857",
      "src": "images/0310252342_content_0031_011.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e858"
    }
  }, [_vm._v("The warden was waiting for Lanie as she walked down the long hall to exit the building. “Lanie, I don’t think your dad’s doing too well.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e860"
    }
  }, [_vm._v("Lanie stared at the warden, feeling a cold chill overtake her. “You mean he’s been into trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e863"
    }
  }, [_vm._v("“No. Nothing like that. He’s a model prisoner. But he’s not eating right and he’s losing weight.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e865"
    }
  }, [_vm._v("“Has he seen the doctor?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e867"
    }
  }, [_vm._v("“Well, he went once, but there wasn’t much the doctor could tell. Forrest is like a lot of men. He doesn’t like to talk about his ailments.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e869"
    }
  }, [_vm._v("But I thought you ought to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e871"
    }
  }, [_vm._v("“Thank you, Warden. I’ll have the church pray for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e873"
    }
  }, [_vm._v("Lanie made her way out to her car, and as she started back to Fairhope, she found herself fighting off her fears. "), _c('i', [_vm._v("Please, God, don’t let ")]), _c('i', [_vm._v("anything happen to Daddy. Let him be healthy and strong.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "0310252342_content_0032_004",
      "id": "d12e879",
      "src": "images/0310252342_content_0032_004.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e880"
    }
  }, [_vm._v("The cold weather continued, and with the holidays over, the early days of January seemed to drag. One morning when school had been cancelled because of a broken boiler, Maeva roamed around the house, restless and bored from being cooped up. “Come on, Cass, let’s go to town.” Maeva winked at Cass. “Maybe we can find some trouble to get into.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e882"
    }
  }, [_vm._v("Cass seemed to be getting used to Maeva’s teasing. “What are we going to town for?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e884"
    }
  }, [_vm._v("“Just to get out of the house. We’ll have to walk though, so put on your warmest clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e886"
    }
  }, [_vm._v("The two girls dressed and headed downtown. Maeva had saved some change, and they bought a candy bar apiece. They were coming out of the grocery store when Alvin Biggins and one of his friends accosted them. “Well, if it ain’t the Freeman girls, one of them anyhow. How you doin’, Maeva?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e889"
    }
  }, [_vm._v("“Get out of the way, Alvin.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e891"
    }
  }, [_vm._v("Maeva could not bear Alvin Biggins. He had been one of the witnesses against her father in the trial that had sent him to the penitentiary. Almost everyone knew that Biggins had lied about the way the shooting had happened, but the jury had no choice but to take his testimony.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e893"
    }
  }, [_vm._v("Alvin winked at his friend. “Now, George, look. We got two good-looking girls here, but one of them done got a cake in the oven.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e895"
    }
  }, [_vm._v("Ain’t that so?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e897"
    }
  }, [_vm._v("Cass flushed and turned her head down, which made Alvin’s lip curl up in a sneer. “Yep, don’t know which one of them boys is responsible, but bound to be one of them. Which one of them made up to you first? Davis, or was it Cody?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e899"
    }
  }, [_vm._v("“You shut your foul mouth, Alvin Biggins!” Maeva cried, anger rising up inside her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e901"
    }
  }, [_vm._v("Biggins barked out a coarse laugh. “You ain’t got nothing to be proud of. Everybody knows you’re wild as a buck anyway. You’ll be just like her. You’ll have a young ’un before you’re a year older.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e903"
    }
  }, [_vm._v("Maeva was anything but a gentle, peaceable girl. Impulsively, she plucked an ax handle out of the barrel that stood on the porch of the store. She gripped it and swung it like a baseball bat. It caught Alvin Biggins on the top of his head, making a clunking sound. He went down bonelessly, and the man called George said, “You done kilt him!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e905"
    }
  }, [_vm._v("“No such luck. Can’t kill a Biggins by hitting ’em in the head.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e907"
    }
  }, [_vm._v("Ed Hathcock, the chief of police, had been strolling down the street looking in the windows. He scurried over and stammered, “What’d you hit him fer, Maeva?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e909"
    }
  }, [_vm._v("“He used rude language. I can’t abide rude language, Chief.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e912"
    }
  }, [_vm._v("“Well, I’m going to have to arrest you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e914"
    }
  }, [_vm._v("“You mean it’s against the law to hit scum like that? I thought this was America.” She turned and said, “Cass, you better go tell Lanie I’m in jail maybe for murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e916"
    }
  }, [_vm._v("“Oh, no. Don’t tell her that. He’s all right. See?” Hathcock reached down and pulled Alvin to his feet. “What was this all about, Biggins? Was you using vile language?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e918"
    }
  }, [_vm._v("“No. I wasn’t doing nothing. She just cracked me over the head for nothing!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e920"
    }
  }, [_vm._v("“Well, get out of here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e922"
    }
  }, [_vm._v("“No, I ain’t. I’m bringing charges against her.” The blood was running down his ear, and he wiped it off with his sleeve. “Hey, look at that! I’m bleeding to death! Now you arrest her. I’m bringing charges!”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "0310252342_content_0034_001",
      "id": "d12e924",
      "src": "images/0310252342_content_0034_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e925"
    }
  }, [_vm._v("Just around the corner from where her sister had driven Alvin Big-gins to the ground with an ax handle, Lanie was coming out of Pink’s Drugstore. She heard her name called and turned to see a woman she had met in church the week before. “Well, it’s Mrs. Wright, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e927"
    }
  }, [_vm._v("“That’s right. And your name is Lanie Freeman. I remember you from church.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e929"
    }
  }, [_vm._v("“We were very glad you came to visit with us, Mrs. Wright. I hope you come back.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e931"
    }
  }, [_vm._v("Amelia Wright was in her late twenties, a well-shaped woman with a wealth of strawberry blonde hair and rather striking green eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e934"
    }
  }, [_vm._v("She had a full lower lip, and her smile exposed perfect teeth. “I wanted to ask you something, Lanie. I’ve been coming down with something, and I need to go to a doctor. Can you recommend one?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e936"
    }
  }, [_vm._v("“I surely can, and here he comes right now.” Lanie smiled. She nodded to Owen Merritt, who was walking toward them. He saw Lanie and gave a small wave. “Doctor Merritt, have you met the newest member of our community?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e938"
    }
  }, [_vm._v("“I don’t believe so.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e940"
    }
  }, [_vm._v("“This is Mrs. Amelia Wright. She came to our church last Sunday. She needs to see a doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e942"
    }
  }, [_vm._v("Amelia Wright smiled. “You know how it is, Doctor. When you go to a new town, you don’t know anybody. When you go to a repairman, you’re liable to get the worst one in the country.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e944"
    }
  }, [_vm._v("“Or the worst doctor?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e946"
    }
  }, [_vm._v("“I don’t think that’ll be the case.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e948"
    }
  }, [_vm._v("“Well, I’m on my way to make some house calls right now, but if you’d like to come to the office at the end of the day, say 5:30, I’ll be glad to see you then.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e950"
    }
  }, [_vm._v("“I would like that.” Amelia turned to Lanie. “Thank you. I enjoyed your singing in church Sunday.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e952"
    }
  }, [_vm._v("“Maybe you’d like to join our choir.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e954"
    }
  }, [_vm._v("“How nice of you to say so. Well, I will see you later, Doctor.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e957"
    }
  }, [_vm._v("“Certainly,” Owen nodded and headed for his car.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e959"
    }
  }, [_vm._v("Lanie watched Amelia Wright walk away. Amelia was an attractive woman, and Lanie wondered for a moment if Owen had noticed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e961"
    }
  }, [_vm._v("Lanie shrugged. At least Amelia would be a welcome member to the choir.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e963"
    }
  }, [_vm._v("Lanie had just turned to get in the old Ford pickup when Cass came running down the street. “Lanie! Lanie! Maeva’s been arrested for assault!”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-827626c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Morr_9780310252344_epub_c7_r1.vue
// module id = 84
// module chunks = 0